import type { PinLoginOutcome } from "../../../shell-handle/quickLogin";

type PinLoginFailureStatus = Exclude<
  PinLoginOutcome["status"],
  "online" | "offline" | "notFound"
>;

interface PinLoginFailure {
  message: string;
  offlineMessage?: string;
  lock: boolean;
}

const EXPIRED =
  "Your quick login has expired. Log in with your password to renew it.";

export const PIN_LOGIN_FAILURES: Record<
  PinLoginFailureStatus,
  PinLoginFailure
> = {
  wrongPin: { message: "Incorrect PIN.", lock: false },
  wiped: {
    message: "Too many incorrect attempts. Log in with your password.",
    offlineMessage:
      "Too many incorrect attempts. Log in with your password when you're back online.",
    lock: true,
  },
  expired: {
    message: EXPIRED,
    offlineMessage:
      "Your offline session has expired. Log in with your password when you're back online.",
    lock: true,
  },
  refused: { message: EXPIRED, lock: true },
  noSnapshot: {
    message:
      "Offline login isn't available on this device yet. Log in online first.",
    lock: false,
  },
};
